<template>
    <v-container class="ma-0 pa-0" align="left">
        <v-img :src="require('@/assets/vil-du-vide-mere.png')" class="mb-5" v-if="knowMore"/>
        <h3>Så skriv til os og lad os mødes</h3>
        <div>
            Vi vil meget gerne lære dig og din virksomhed at kende – og vise dig hvilken værdi, du kan få af dit
            eget gofiqr-univers
        </div>
        <v-form ref="contactForm" v-model="valid" lazy-validation>
            <v-text-field v-model="name" :counter="100" :rules="nameRules" label="Navn" required/>
            <v-text-field v-model="email" :counter="250" :rules="emailRules" label="Mail" required/>
            <v-text-field v-model="subject" :counter="100" :rules="subjectRules" label="Emne" required/>
            <v-textarea v-model="message" :counter="2000" :rules="messageRules" label="Besked" required/>
            <v-btn small class="mr-4" @click="postContact" :disabled="!valid">Send</v-btn>
            <v-btn small @click="reset">Nulstil</v-btn>
            <v-snackbar color="error" v-model="errorAlert">
                Kunne ikke sende meddelelsen
            </v-snackbar>
            <v-snackbar color="info" v-model="okAlert">
                Meddelelsen er sendt
            </v-snackbar>
        </v-form>
        <TryGofiqr v-if="tryGofiqr"/>
    </v-container>
</template>

<script>
    import TryGofiqr from "@/components/TryGofiqr";
    import fbfunc from "@/components/FirebaseInit";
    import {load} from 'recaptcha-v3';

    export default {
        name: 'ContactForm',
        components: {TryGofiqr},
        props: {
            knowMore: {
                default: false,
                type: Boolean,
            },
            tryGofiqr: {
                default: false,
                type: Boolean,
            }
        },
        data: () => ({
            valid: false,
            subject: '',
            message: '',
            name: '',
            nameRules: [
                v => !!v || 'Navn skal udfyldes',
                v => (v && v.length <= 100) || 'Navn må ikke være længere end 100 tegn',
            ],
            email: '',
            emailRules: [
                v => !!v || 'Mail adresse skal udfyldes',
                v => (v && v.length <= 250) || 'Mail adresse må ikke være længere end 250 tegn',
                v => /^\S+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(v) || 'Mail adresse skal være valid',
            ],
            subjectRules: [
                v => !!v || 'Emne skal udfyldes',
                v => (v && v.length <= 100) || 'Emne må ikke være længere end 100 tegn',
            ],
            messageRules: [
                v => !!v || 'Besked skal udfyldes',
                v => (v && v.length <= 2000) || 'Beskeden må ikke være længere end 2000 tegn',
            ],
            errorAlert: false,
            okAlert: false
        }),

        methods: {
            postContact() {
                // this.errorAlert = true;
                if (this.$refs.contactForm.validate()) {
                    load('6LejctwUAAAAAA6skeToMzeAqLVNPEMJSIZP3cOn').then((recaptcha) => {
                        recaptcha.execute('contact').then((token) => {
                            console.log('Token at send: ' + token);
                            const contactMailer = fbfunc.httpsCallable('contactMailer');
                            contactMailer({
                                name: this.name,
                                email: this.email,
                                subject: this.subject,
                                message: this.message,
                                mailer: 'gofiqr',
                                token: token
                            }).then(result => {
                                if (result.data.status === 'OK') {
                                    this.okAlert = true;
                                    this.reset();
                                } else {
                                    this.errorAlert = true;
                                }
                            }).catch(err => {
                                console.error('Error at httpCallable: ', err);
                                this.errorAlert = true;
                            });
                        });
                    }).catch(err => {
                        console.error('Error when recaptcha:', err);
                        this.errorAlert = true;
                    });

                    /*
                    db.collection('contact').add({
                        subject: this.subject,
                        name: this.name,
                        email: this.email,
                        message: this.message
                    })
                        .then(docref => {
                            console.log('Contact written with ID: ', docref.id);
                        })
                        .catch(err => {
                            console.error('Error adding document: ', err);
                            this.errorAlert = true;
                        });

                     */
                }
            },
            reset() {
                this.$refs.contactForm.reset();
            },
            recaptcha() {
                load('6LejctwUAAAAAA6skeToMzeAqLVNPEMJSIZP3cOn').then((recaptcha) => {
                    recaptcha.execute('contact').then((token) => {
                        console.log(token);
                    });
                }).catch(err => {
                    console.error('Error when recaptcha:', err);
                    this.errorAlert = true;
                });
            },
        }
    }
</script>
